import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationEnd, RouterModule, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';

import { HeaderComponent } from './components/header/header.component';
import { HeroComponent } from './components/hero/hero.component';
import { FooterComponent } from './footer/footer.component';
import { InstagramSectionComponent } from './components/instagram-section/instagram-section.component';
import { LoginComponent } from './components/login/login.component';
import { SocialLinksComponent } from './components/social-links/social-links.component';
import { YoutubeFeatureComponent } from './components/youtube-feature/youtube-feature.component';
import { LocationMapComponent } from './components/location-map/location-map.component';
import { ToastComponent } from './components/toast/toast.component';

@Component({
    selector: 'app-root',
    imports: [
    HeaderComponent,
    RouterModule,
    FooterComponent,
    LoginComponent,
    RouterOutlet,
    ToastComponent
],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  showHeader = true;
  message: string = '';
  messageLog: string[] = [];
  isConnected = false;

  isAdminPanelOpen = false;
  isAdminDashboardVisible = false;
  isAdminLoggedIn = false;
  adminInsights = {};
  cdr: any;


  ngOnInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

  }

  toggleAdminPanel() {
    this.isAdminPanelOpen = !this.isAdminPanelOpen;
  }

  toggleAdminDashboard() {
    this.isAdminDashboardVisible = !this.isAdminDashboardVisible;
  }

  handleAdminLoginSuccess() {
    this.isAdminLoggedIn = true;
    this.isAdminPanelOpen = false; // close login
    this.isAdminDashboardVisible = true; // open dashboard

    this.adminInsights = {
      visitsToday: 42,
      visitsThisWeek: 231,
      activeUsers: 17
    };
    this.cdr.detectChanges(); // force refresh
  }

}
